// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2lR5y","title":"Images45_title__3nykf","images":"Images45_images__2EsF9"};